@use 'src/global/variables' as var;


c-form-radio {
    input[type=radio] {
      position: absolute;
      width: 1rem;
      height: 1rem;
      margin: 0;
      opacity: 0;
      z-index: 2;
    }

    .btn-group input[type=radio]+label {
      border-radius: 10px !important;
      display: block;
      padding: 10px;
      transition: border-color .08s, background-color .08s, box-shadow .08s;
      border: 1px solid black;
      width: 85%;
      background: #fff !important;
      line-height: 1.3125rem;
      overflow: hidden;
      text-align: center;
    }

    .btn-group input[type=radio]:checked+label{
      background-color: var.$primary-color !important;
      color: white !important;
     }

    .form-check {
      padding-top: 10px;
    }

    .btn-group {
      margin-bottom: 10px;

        .left {
            margin-right: 8px !important;
            max-width: 40% !important;
        }

        .right {
            margin-left: 8px !important;
            max-width: 40% !important;
        }
    }

    label,
    input[type=radio] {
      margin-left: 5% !important;
    }
}

